import { useCallback, useState } from 'react';
import { readSidebarCollapsed, SIDEBAR_COLLAPSED_KEY } from '../utils/sidebarPreferences';

export default function useSidebarState() {
  const [collapsed, setCollapsed] = useState(readSidebarCollapsed);
  const setPreference = useCallback(value => {
    setCollapsed(previous => {
      const next = typeof value === 'function' ? value(previous) : value;
      try { localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(next)); } catch (_) { /* Storage is optional. */ }
      return next;
    });
  }, []);
  return [collapsed, setPreference];
}
